module.exports = __webpack_public_path__ + "img/deyu_littletitle_bg.deeabcf9.png";